const initGenderToggle = (target, select) => {
    const toggle = (value) => {
        target.style.display = value ? null : 'none';
        target.querySelector('input').disabled = !value;
    };
    select.addEventListener('change', () => {
        toggle(select.value === '3');
    });

    toggle(select.value === '3');
};

const toggleTargets = (targets) => (value) =>
    targets.forEach((id) => {
        const target = document.getElementById(id);
        if (target) {
            target.style.display = value ? null : 'none';
            target.querySelector('input').disabled = !value;
        }
    });

export default function enrolmentForm() {
    const target = document.getElementById('sq_form_field_wrapper_q299747_q6');
    if (target) {
        initGenderToggle(target, document.getElementById('q299747_q5'));
    }

    const toggleAddress = toggleTargets([
        'sq_form_field_wrapper_q299746_q6',
        'sq_form_field_wrapper_q299746_q7',
        'sq_form_field_wrapper_q299746_q8',
    ]);

    const caretakerQs = [...Array(11).keys()]
        .map((value) => `sq_form_field_wrapper_q302127_q${value + 1}`)
        .filter((str) => !/q(8|9|10)$/.test(str));

    const toggleCaretaker = toggleTargets(caretakerQs);

    const toggleCaretakerAddress = toggleTargets([
        'sq_form_field_wrapper_q302127_q8',
        'sq_form_field_wrapper_q302127_q9',
        'sq_form_field_wrapper_q302127_q10',
    ]);

    const radioToggles = [
        ['q299746:q10', toggleAddress],
        ['q302127:q12', toggleCaretaker, toggleCaretakerAddress],
        ['q302127:q7', toggleCaretakerAddress],
    ];

    const addressChecked =
        document.querySelector('[name="q302127:q7"]:checked')?.value === '1';

    toggleAddress(false);
    toggleCaretaker(false);
    toggleCaretakerAddress(false);

    radioToggles.forEach((arr) =>
        document.querySelectorAll(`[name="${arr[0]}"]`).forEach((item) => {
            if (item.checked) {
                arr[1](item.value === '1');
                arr[2]?.(addressChecked && item.value === '1');
            }

            item.addEventListener('change', (e) =>
                arr[1](e.target.value === '1')
            );
        })
    );
}
